import { ComponentRoute } from '@/classes'

const DebtorReceiptRoutes = {
  DebtorReceiptListView: new ComponentRoute('/debtorsreceipts', 'DebtorReceiptListView')
}

export default DebtorReceiptRoutes
